"use client";

import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";

import { isRouteFocusSuppressed } from "@/lib/route-focus";

export function RouteFocusReset() {
  const pathname = usePathname();
  const firstRender = useRef(true);
  const sentinelRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    // A page asked to keep its own focus across this navigation — don't reset.
    if (isRouteFocusSuppressed()) return;
    const focus = () => sentinelRef.current?.focus({ preventScroll: true });
    focus();
    const raf = requestAnimationFrame(focus);
    return () => cancelAnimationFrame(raf);
  }, [pathname]);

  return <span ref={sentinelRef} tabIndex={-1} className="sr-only" />;
}
